import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Area } from '../../../../core/constants/area';
import { ToastrService } from 'ngx-toastr';
import { ConsoleLogger } from '../../../../core/utilities/console-logger';
import { finalize } from 'rxjs/operators/finalize';
import { RetrieveCarriersResponse } from './models/responses/retrieve-carriers-response.model';
import { PushCarriersResponse } from './models/responses/push-carriers-response.model';
import { ConfirmDialogService } from '../../../../core/components/confirm-dialog/confirm-dialog.service';
import { FMCSAAuditResponse } from './models/responses/fmcsa-audit-response.model';
import { FMCSAAuditRow } from './models/models/fmcsa-audit-view.model';
import { AtoBFuelCardSyncResponse } from './models/responses/atob-fuel-card-sync-response.model';
import { RolloverQuarterlySafetyDocumentsResponse } from './models/responses/rollover-quarterly-safety-documents-response.model';
import { DatePipe } from '@angular/common';
import { HubSpotSandboxService } from '../../../services/hubspot-sandbox.service';
import { ScheduledJobMessageResponse } from './models/responses/scheduled-job-message-response.model';
import { QueueQuarterlyStatementsResponse } from './models/responses/queue-quarterly-statements-response.model';

@Component({
    selector: 'app-scheduled-jobs',
    templateUrl: './scheduled-jobs.component.html',
    styleUrls: ['./scheduled-jobs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [HubSpotSandboxService]
})
export class ScheduledJobsComponent implements OnInit {

    isLoadingIpAddress = false;
    isRunningTransportJobs = false;
    isRunningQueueJobs = false;
    isRunningCreditCheckJobs = false;
    isRunningDebtorSync = false;
    isRunningFCDataSync = false;
    isRunningWinFactorImport = false;

    isRunningCollectionsReminder = false;
    isRunningUSATruck = false;
    public isRunningQuarterlySafetyDocumentRollover = false;
    private isConfirmingQuarterlySafetyDocumentRollover = false;

    fmcsaAddDate = '';
    fmcsaWindowDays = 7;
    fmcsaWindowRangeLabel = '';
    fmcsaMaxItems = 10000;

    isRunningFMCSAByAddDateConsole = false;
    isRunningFMCSAByWindowConsole = false;
    isPushingFMCSA = false;
    private isConfirmingFMCSAPush = false;

    // FMCSA Carrier Push Audit (preview-only)
    auditStartDate = '';
    auditEndDate = '';
    isRunningAudit = false;
    hasRunAudit = false;
    auditError = '';
    auditRows: FMCSAAuditRow[] = [];
    private datePipe = new DatePipe('en-US');

    // AtoB fuel card sync
    isRunningAtoBSync = false;
    private isConfirmingAtoBSync = false;
    private isConfirmingMonthlySafetyEmails = false;
    atoBSyncError = '';
    atoBSyncResult: AtoBFuelCardSyncResponse = null;

    quarterlyStatementCompanyId: number = null;
    isQueuingQuarterlyStatements = false;
    private isConfirmingQuarterlyStatements = false;
    quarterlyStatementsResult: QueueQuarterlyStatementsResponse = null;


    jobs = [
        { label: 'Scheduled Jobs - Transportation Data Maintenance', action: () => this.runTransportationDataMaintenance() },
        { label: 'Scheduled Jobs - Transportation Hold Past Due Companies', action: () => this.runTransportationHoldCompany() },
        { label: 'Scheduled Jobs - Transportation Process Pending Journal Entries', action: () => this.processJournalEntries() },
        { label: 'Scheduled Jobs - Transportation Process Message Status Updates', action: () => this.processMessageStatusUpdates() },
        { label: 'Safety - Quarterly Document Rollover', action: () => this.runQuarterlySafetyDocumentRollover() },
        { label: 'Queue Jobs - Fill Notification Queue', action: () => this.fillNotificationQueue() },
        { label: 'Queue Jobs - Process Notification Queue', action: () => this.processNotificationQueue() },
        { label: 'Queue Jobs - Generate Collections Reminder List', action: () => this.runCollectionsReminderList() },
        { label: 'Queue Jobs - Fill Subscription Queue', action: () => this.processSubscriptionQueue() },
        { label: 'Queue Jobs - Send Monthly Safety Compliance Emails', action: () => this.sendMonthlySafetyComplianceEmails() },
        { label: 'Credit Check - Factoring Update Credit Risk', action: () => this.runUpdateCreditRisk() },
        { label: 'USATruck - Process Invoices', action: () => this.processUSATruckInvoices() },
        { label: 'FactorCloud - Debtor Sync', action: () => this.factorCloudDebtorSync() },
        { label: 'FactorCloud - Import To Portal', action: () => this.factorCloudDataSync() },
        { label: 'FactorCloud - Historical Import To Portal (all data)', action: () => this.factorCloudDataSync(true) },
        { label: 'FactorCloud - Import Terms', action: () => this.factorCloudTermsSync() },
        { label: 'WinFactor - Import To Portal', action: () => this.winFactorDataImport() },
    ]

    selectedJob: any;

    constructor(
        private http: HttpClient,
        private toastrService: ToastrService,
        private confirmDialogService: ConfirmDialogService,
        public sandbox: HubSpotSandboxService
    ) { }

    ngOnInit() {
        this.fmcsaAddDate = this.defaultAddDate();
        this.initAuditDateRange();
        this.updateWindowRangeLabel();
    }

    fillNotificationQueue() {
        this.isRunningQueueJobs = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/scheduledJobs/Queue/Fill`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.toastrService.success(
                        'Fill notification queue Job was successfully run.'
                    );
                    this.isRunningQueueJobs = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error('Fill notification queue job failed to run.');
                    this.isRunningQueueJobs = false;
                }
            );
    }

    processJournalEntries() {
        this.isRunningTransportJobs = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/ScheduledJobs/JE/Process`,
                {}
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    this.toastrService.success(
                        'Pending journal entries have been processed.'
                    );
                    this.isRunningTransportJobs = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error('Pending journal entries failed to process.');
                    this.isRunningTransportJobs = false;
                }
            );
    }

    processMessageStatusUpdates() {
        this.isRunningTransportJobs = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/ScheduledJobs/MessageStatusUpdates`,
                {}
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    this.toastrService.success(
                        `Message status updates processed successfully. Updated ${response} messages.`
                    );
                    this.isRunningTransportJobs = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error('Message status updates failed to process.');
                    this.isRunningTransportJobs = false;
                }
            );
    }

    processNotificationQueue() {
        this.isRunningQueueJobs = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/scheduledJobs/Queue`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.toastrService.success(
                        'Scheduled job for processing notification queue was successfully run.'
                    );
                    this.isRunningQueueJobs = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Scheduled job for processing notification queue failed to run.'
                    );
                    this.isRunningQueueJobs = false;
                }
            );
    }

    processSubscriptionQueue() {
        this.isRunningQueueJobs = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/scheduledJobs/Subscription`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.toastrService.success(
                        'Scheduled job for processing subscription queue was successfully run.'
                    );
                    this.isRunningQueueJobs = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Scheduled job for processing subscription queue failed to run.'
                    );
                    this.isRunningQueueJobs = false;
                }
            );
    }

    public sendMonthlySafetyComplianceEmails() {
        if (this.isRunningQueueJobs || this.isConfirmingMonthlySafetyEmails) {
            return;
        }

        this.isConfirmingMonthlySafetyEmails = true;
        this.confirmDialogService.showConfirm(
            'This queues the monthly safety compliance email for every active safety company. Would you like to continue?',
            () => {
                this.isConfirmingMonthlySafetyEmails = false;
                this.startMonthlySafetyComplianceEmails();
            },
            () => { this.isConfirmingMonthlySafetyEmails = false; }
        );
    }

    private startMonthlySafetyComplianceEmails() {
        this.isRunningQueueJobs = true;
        this.http
            .post<ScheduledJobMessageResponse>(
                `${environment.dotNetApiUrl}/${Area.transportation}/ScheduledJobs/MonthlySafetyComplianceEmails`,
                {}
            )
            .pipe(finalize(() => (this.isRunningQueueJobs = false)))
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    this.toastrService.success(response.message);
                },
                (err) => {
                    ConsoleLogger.logInfo('Monthly safety compliance emails request closed:', err);
                    const requestDropped = err && (err.name === 'TimeoutError' || err.status === 0 || err.status === 502 || err.status === 504);
                    if (requestDropped) {
                        this.toastrService.info(
                            'The request closed before the job finished. The job may still be running on the server. Check the job logs before retrying.',
                            'Monthly safety compliance emails'
                        );
                    }
                }
            );

        this.toastrService.info(
            'Monthly safety compliance emails started. This can take several minutes.',
            'Job started'
        );
    }

    public queueQuarterlyStatements() {
        if (this.isQueuingQuarterlyStatements || this.isConfirmingQuarterlyStatements) {
            return;
        }

        if (this.quarterlyStatementCompanyId) {
            this.startQuarterlyStatements();
            return;
        }

        this.isConfirmingQuarterlyStatements = true;
        this.confirmDialogService.showConfirm(
            'This generates last quarter\'s statement and queues the email for every eligible company that has not been sent one this quarter. Would you like to continue?',
            () => {
                this.isConfirmingQuarterlyStatements = false;
                this.startQuarterlyStatements();
            },
            () => { this.isConfirmingQuarterlyStatements = false; }
        );
    }

    private startQuarterlyStatements() {
        this.isQueuingQuarterlyStatements = true;
        this.quarterlyStatementsResult = null;

        let params = new HttpParams();
        if (this.quarterlyStatementCompanyId) {
            params = params.set('companyId', String(this.quarterlyStatementCompanyId));
        }

        this.http
            .post<QueueQuarterlyStatementsResponse>(
                `${environment.dotNetApiUrl}/${Area.transportation}/ScheduledJobs/Queue/QuarterlyStatements`,
                {},
                { params }
            )
            .pipe(finalize(() => (this.isQueuingQuarterlyStatements = false)))
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    this.quarterlyStatementsResult = response;
                    this.toastrService.success(response.message);
                },
                (err) => {
                    ConsoleLogger.logInfo('Quarterly statements request closed:', err);
                    const requestDropped = err && (err.name === 'TimeoutError' || err.status === 0 || err.status === 502 || err.status === 504);
                    if (requestDropped) {
                        this.toastrService.info(
                            'The request closed before the job finished. The job may still be running on the server. Check the notification queue before retrying.',
                            'Quarterly statements'
                        );
                    }
                }
            );
    }

    processUSATruckInvoices() {
        this.isRunningUSATruck = true;
        this.http
            .post<any>(
              `${environment.dotNetApiUrl}/${Area.transportation}/ScheduledJobs/USATruck/ProcessInvoices`,
                {}
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                this.toastrService.success(response.message);
                this.isRunningUSATruck = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error('Failed to process USATruck invoices. ' + err.message);
                    this.isRunningUSATruck = false;
                }
            );
    }

    factorCloudDebtorSync() {
      this.isRunningDebtorSync = true;
      this.http
        .post<any>(
          `${environment.dotNetApiUrl}/${Area.factoring}/FactoringScheduledJobs/FactorCloud/ProcessDebtorSync`,
          {}
        )
        .subscribe(
          (response) => {
            ConsoleLogger.logInfo(response);
            this.toastrService.success(response.message);
            this.isRunningDebtorSync = false;
          },
          (err) => {
            console.error('Error:', err);
            this.toastrService.error('Failed to sync debtors with FactorCloud. ' + err.message);
            this.isRunningDebtorSync = false;
          }
        );
  }

  factorCloudDataSync(pullAllInvoices: boolean = false) {
    this.isRunningFCDataSync = true;
    this.http
      .post<any>(
        `${environment.dotNetApiUrl}/${Area.factoring}/FactoringScheduledJobs/FactorCloud/ProcessDataSync`,
        { pullAllInvoices }
      )
      .subscribe(
        (response) => {
          ConsoleLogger.logInfo(response);
          this.toastrService.success(response.message);
          this.isRunningFCDataSync = false;
        },
        (err) => {
          console.error('Error:', err);
          this.toastrService.error('Failed to sync data with FactorCloud. ' + err.message);
          this.isRunningFCDataSync = false;
        }
      );
  }

  factorCloudTermsSync() {
    this.isRunningFCDataSync = true;
    this.http
      .post<any>(
        `${environment.dotNetApiUrl}/${Area.factoring}/FactoringScheduledJobs/FactorCloud/ProcessTermsSync`,
        {}
      )
      .subscribe(
        (response) => {
          ConsoleLogger.logInfo(response);
          this.toastrService.success(response.message);
          this.isRunningFCDataSync = false;
        },
        (err) => {
          console.error('Error:', err);
          const detail = err && err.error && err.error.error ? err.error.error : err.message;
          this.toastrService.error('Failed to import FactorCloud terms. ' + detail);
          this.isRunningFCDataSync = false;
        }
      );
  }

  winFactorDataImport() {
    this.isRunningWinFactorImport = true;
    this.http
      .post<any>(
        `${environment.dotNetApiUrl}/${Area.factoring}/FactoringScheduledJobs/WinFactor/ProcessDataImport`,
        {}
      )
      .subscribe(
        (response) => {
          ConsoleLogger.logInfo(response);
          this.toastrService.success(response.message);
          this.isRunningWinFactorImport = false;
        },
        (err) => {
          console.error('Error:', err);
          this.toastrService.error('Failed to import WinFactor data. ' + err.message);
          this.isRunningWinFactorImport = false;
        }
      );
  }


    runCollectionsReminderList() {
        this.isRunningCollectionsReminder = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/ScheduledJobs/CollectionsReminder`,
                {}
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    this.toastrService.success(
                        response.message || 'Collections reminder list generated successfully.'
                    );
                    this.isRunningCollectionsReminder = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error('Collections reminder list generation failed.');
                    this.isRunningCollectionsReminder = false;
                }
            );
    }

    //This is not used anywhere in the application, but I left it in incase we need it (developer portal refacotr). BP - 09/25/2025 10:20 AM
    runEndOfMonthInvoices() {
        this.isRunningQueueJobs = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/scheduledJobs/Queue/EOM`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.toastrService.success(
                        'End of month invoices queue job was successfully run.'
                    );
                    this.isRunningQueueJobs = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'End of month invoices queue job failed to run.'
                    );
                    this.isRunningQueueJobs = false;
                }
            );
    }

    public runQuarterlySafetyDocumentRollover(): void {
        if (this.isRunningQuarterlySafetyDocumentRollover || this.isConfirmingQuarterlySafetyDocumentRollover) {
            return;
        }

        this.isConfirmingQuarterlySafetyDocumentRollover = true;
        this.confirmDialogService.showConfirm(
            'This archives quarterly safety documents from earlier quarters, along with any active quarterly safety documents that have no issue date, and creates current-quarter placeholders on every active Company Safety File that doesn\'t already have one. Would you like to continue?',
            () => {
                this.isConfirmingQuarterlySafetyDocumentRollover = false;
                this.startQuarterlySafetyDocumentRollover();
            },
            () => { this.isConfirmingQuarterlySafetyDocumentRollover = false; }
        );
    }

    private startQuarterlySafetyDocumentRollover(): void {
        if (this.isRunningQuarterlySafetyDocumentRollover) {
            return;
        }

        this.isRunningQuarterlySafetyDocumentRollover = true;
        this.http
            .post<RolloverQuarterlySafetyDocumentsResponse>(
                `${environment.dotNetApiUrl}/${Area.transportation}/scheduledJobs/QuarterlySafetyDocuments/Rollover`,
                {}
            )
            .subscribe(
                (response) => {
                    ConsoleLogger.logInfo(response);
                    this.toastrService.success(response.message);
                    this.isRunningQuarterlySafetyDocumentRollover = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.isRunningQuarterlySafetyDocumentRollover = false;
                }
            );
    }

    runSelectedJob() {
        if (this.selectedJob && this.selectedJob.action) {
            this.selectedJob.action();
        }
    }

    runTransportationDataMaintenance() {
        this.isRunningTransportJobs = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/scheduledJobs`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.toastrService.success(
                        'Scheduled jobs for transportation data maintenance was successfully run.'
                    );
                    this.isRunningTransportJobs = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Scheduled jobs for transportation data maintenance failed to run.'
                    );
                    this.isRunningTransportJobs = false;
                }
            );
    }

    runTransportationHoldCompany() {
        this.isRunningTransportJobs = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/scheduledJobs/PutCompanyOnHold`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.toastrService.success(
                        'Scheduled jobs for transportation putting companies on hold was successfully run.'
                    );
                    this.isRunningTransportJobs = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Scheduled jobs for transportation putting companies on hold failed to run.'
                    );
                    this.isRunningTransportJobs = false;
                }
            );
    }

    runUpdateCreditRisk() {
        this.isRunningCreditCheckJobs = true;
        this.http
            .get(
                `${environment.dotNetApiUrl}/${Area.factoring}/Client/LoadCreditRisk`,
                { responseType: 'text' }
            )
            .pipe(finalize(() => (this.isLoadingIpAddress = false)))
            .subscribe((res) => {
                this.isRunningCreditCheckJobs = false;
            });
    }

    retrieveFMCSAByAddDate() {
        const daysAgo = this.computeDaysAgoFromDate(this.fmcsaAddDate);
        if (daysAgo === null) {
            return;
        }

        this.isRunningFMCSAByAddDateConsole = true;
        const params = new HttpParams()
            .set('daysAgo', String(daysAgo))
            .set('push', 'false')
            .set('maxItems', String(this.fmcsaMaxItems));

        this.http
            .post<RetrieveCarriersResponse>(
                `${environment.dotNetApiUrl}/${Area.transportation}/ScheduledJobs/FMCSACarriers/ByAddDate`,
                {},
                { params }
            )
            .pipe(finalize(() => (this.isRunningFMCSAByAddDateConsole = false)))
            .subscribe(
                (response) => {
                    this.toastrService.success(
                        `Retrieved ${response.totalRetrieved} carriers. Check console for details.`
                    );
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error('Failed to retrieve FMCSA carriers.');
                }
            );
    }

    pushFMCSAByAddDate() {
        const daysAgo = this.computeDaysAgoFromDate(this.fmcsaAddDate);
        if (daysAgo === null) {
            return;
        }

        const params = new HttpParams()
            .set('daysAgo', String(daysAgo))
            .set('push', 'true')
            .set('maxItems', String(this.fmcsaMaxItems));

        this.confirmAndStartPush('ByAddDate', params);
    }

    retrieveFMCSAByWindow() {
        this.isRunningFMCSAByWindowConsole = true;
        const params = new HttpParams()
            .set('windowDays', String(this.fmcsaWindowDays))
            .set('push', 'false')
            .set('maxItems', String(this.fmcsaMaxItems));

        this.http
            .post<RetrieveCarriersResponse>(
                `${environment.dotNetApiUrl}/${Area.transportation}/ScheduledJobs/FMCSACarriers/ByWindow`,
                {},
                { params }
            )
            .pipe(finalize(() => (this.isRunningFMCSAByWindowConsole = false)))
            .subscribe(
                (response) => {
                    this.toastrService.success(
                        `Retrieved ${response.totalRetrieved} carriers. Check console for details.`
                    );
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error('Failed to retrieve FMCSA carriers.');
                }
            );
    }

    pushFMCSAByWindow() {
        const params = new HttpParams()
            .set('windowDays', String(this.fmcsaWindowDays))
            .set('push', 'true')
            .set('maxItems', String(this.fmcsaMaxItems));

        this.confirmAndStartPush('ByWindow', params);
    }

    private confirmAndStartPush(mode: 'ByAddDate' | 'ByWindow', params: HttpParams) {
        // The dialog is not modal, so without this a second click opens a second dialog.
        if (this.isPushingFMCSA || this.isConfirmingFMCSAPush) {
            return;
        }

        this.isConfirmingFMCSAPush = true;
        this.confirmDialogService.showConfirm(
            `Pushing carriers to ${this.sandbox.target()} may take a while to finish. Would you like to continue?`,
            () => {
                this.isConfirmingFMCSAPush = false;
                this.startFMCSAPush(mode, params);
            },
            () => { this.isConfirmingFMCSAPush = false; }
        );
    }

    runAtoBSync(push: boolean) {
        // The dialog is not modal, so without this a second click opens a second dialog.
        if (this.isRunningAtoBSync || this.isConfirmingAtoBSync) {
            return;
        }

        if (!push) {
            this.startAtoBSync(false);
            return;
        }

        this.isConfirmingAtoBSync = true;
        this.confirmDialogService.showConfirm(
            `Pushing AtoB fuel card data updates Deals in ${this.sandbox.target()} and may take a while to finish. Would you like to continue?`,
            () => {
                this.isConfirmingAtoBSync = false;
                this.startAtoBSync(true);
            },
            () => { this.isConfirmingAtoBSync = false; }
        );
    }

    private startAtoBSync(push: boolean) {
        if (this.isRunningAtoBSync) {
            return;
        }

        this.isRunningAtoBSync = true;
        this.atoBSyncError = '';
        this.atoBSyncResult = null;

        const params = this.sandbox.withSandbox(new HttpParams().set('push', String(push)));

        this.http
            .post<AtoBFuelCardSyncResponse>(
                `${environment.dotNetApiUrl}/${Area.transportation}/ScheduledJobs/AtoBFuelCard/Sync`,
                {},
                { params }
            )
            .pipe(finalize(() => (this.isRunningAtoBSync = false)))
            .subscribe(
                (response) => {
                    this.atoBSyncResult = response;
                    ConsoleLogger.logInfo(response);
                    this.toastrService.success(
                        push
                            ? `Updated ${response.dealsUpdated} deal(s) from ${response.customersRetrieved} AtoB customer(s).`
                            : `Retrieved ${response.customersRetrieved} AtoB customer(s).`,
                        'AtoB sync complete'
                    );
                },
                (err) => {
                    this.atoBSyncError = err && err.error ? err.error : 'The AtoB sync request failed.';
                    ConsoleLogger.logInfo('AtoB sync failed:', err);
                }
            );
    }

    private startFMCSAPush(mode: 'ByAddDate' | 'ByWindow', params: HttpParams) {
        if (this.isPushingFMCSA) {
            return;
        }

        this.isPushingFMCSA = true;
        this.http
            .post<PushCarriersResponse>(
                `${environment.dotNetApiUrl}/${Area.transportation}/ScheduledJobs/FMCSACarriers/${mode}`,
                {},
                { params: this.sandbox.withSandbox(params) }
            )
            .pipe(finalize(() => (this.isPushingFMCSA = false)))
            .subscribe(
                (response) => ConsoleLogger.logInfo(response),
                (err) => ConsoleLogger.logInfo('FMCSA push request closed (expected for long-running pushes):', err)
            );

        this.toastrService.info(
            'Push to HubSpot started. Review progress in HubSpot directly.',
            'Push started'
        );
    }

    private computeDaysAgoFromDate(dateStr: string): number | null {
        if (!dateStr) {
            this.toastrService.error('Please select an add date.');
            return null;
        }

        const parts = dateStr.split('-').map((p) => Number(p));
        if (parts.length !== 3 || parts.some((n) => isNaN(n))) {
            this.toastrService.error('Please select a valid add date.');
            return null;
        }

        const [year, month, day] = parts;
        const selectedUtcMidnight = Date.UTC(year, month - 1, day);
        const now = new Date();
        const todayUtcMidnight = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
        const daysAgo = Math.round((todayUtcMidnight - selectedUtcMidnight) / 86400000);

        if (daysAgo < 0) {
            this.toastrService.error('Add date cannot be in the future.');
            return null;
        }

        return daysAgo;
    }

    private defaultAddDate(): string {
        const now = new Date();
        const twoDaysAgo = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - 2));
        const year = twoDaysAgo.getUTCFullYear();
        const month = ('0' + (twoDaysAgo.getUTCMonth() + 1)).slice(-2);
        const day = ('0' + twoDaysAgo.getUTCDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }

    onWindowDaysChange(value: number) {
        this.fmcsaWindowDays = value;
        this.updateWindowRangeLabel();
    }

    updateWindowRangeLabel() {
        const days = Number(this.fmcsaWindowDays);
        if (!days || days < 1) {
            this.fmcsaWindowRangeLabel = '';
            return;
        }
        const end = new Date();
        end.setDate(end.getDate() - 1);
        const start = new Date();
        start.setDate(start.getDate() - days);
        this.fmcsaWindowRangeLabel = `${this.formatDay(start)} - ${this.formatDay(end)}`;
    }

    runFMCSAAudit() {
        if (this.isRunningAudit) {
            return;
        }

        const start = this.parseIso(this.auditStartDate);
        const end = this.parseIso(this.auditEndDate);

        if (!start || !end) {
            this.auditError = 'Enter a valid start and end date.';
            return;
        }
        if (start.getTime() > end.getTime()) {
            this.auditError = 'Start date must be on or before the end date.';
            return;
        }
        const totalDays = Math.round((end.getTime() - start.getTime()) / 86400000) + 1;
        if (totalDays > 366) {
            this.auditError = 'Select a range of 366 days or fewer.';
            return;
        }

        this.auditError = '';
        this.isRunningAudit = true;

        const params = new HttpParams()
            .set('startDate', this.auditStartDate)
            .set('endDate', this.auditEndDate);

        this.http
            .post<FMCSAAuditResponse>(
                `${environment.dotNetApiUrl}/${Area.transportation}/ScheduledJobs/FMCSACarriers/Audit`,
                {},
                { params }
            )
            .pipe(finalize(() => (this.isRunningAudit = false)))
            .subscribe(
                (response) => {
                    this.buildAuditView(response);
                    this.hasRunAudit = true;
                },
                (err) => {
                    console.error('Error:', err);
                    const serverMessage = err && err.error && err.error.error ? err.error.error : null;
                    this.auditError = serverMessage || 'Failed to run the FMCSA carrier audit.';
                    this.auditRows = [];
                    this.hasRunAudit = true;
                }
            );
    }

    private buildAuditView(response: FMCSAAuditResponse) {
        const days = response && response.days ? response.days : [];

        this.auditRows = days.slice().reverse().map((d): FMCSAAuditRow => {
            const parsed = this.parseIso(d.date);
            return {
                dateLabel: parsed ? this.formatDay(parsed) : d.date,
                wouldPush: d.wouldPushCount,
                alreadyExists: d.alreadyExistsCount
            };
        });
    }

    private initAuditDateRange() {
        const today = new Date();
        const start = new Date();
        today.setDate(today.getDate() - 1)
        start.setDate(start.getDate() - 7);
        this.auditEndDate = this.toLocalIso(today);
        this.auditStartDate = this.toLocalIso(start);
    }

    private toLocalIso(d: Date): string {
        const year = d.getFullYear();
        const month = ('0' + (d.getMonth() + 1)).slice(-2);
        const day = ('0' + d.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }

    private parseIso(dateStr: string): Date | null {
        if (!dateStr) {
            return null;
        }
        const parts = dateStr.split('-').map((p) => Number(p));
        if (parts.length !== 3 || parts.some((n) => isNaN(n))) {
            return null;
        }
        const [year, month, day] = parts;
        return new Date(year, month - 1, day);
    }

    private formatDay(d: Date): string {
        return `${this.datePipe.transform(d, 'EEE, MMMM')} ${this.ordinal(d.getDate())}`;
    }

    private ordinal(n: number): string {
        const s = ['th', 'st', 'nd', 'rd'];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }
}



// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/scheduled-jobs/scheduled-jobs.component.ts